import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BiometricsService } from '../services/biometrics.service';

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
  // Check if the request URL contains OasUrl
  const oasUrl = environment.OASUrl();
  const notificationsUrl = environment.NotificationsUrl();
  if (!req.url.includes(oasUrl) && !req.url.includes(notificationsUrl) && !req.url.includes(environment.AuthUrl())) {
    return next(req);
  }

  // Get platform from biometric service
  const bioS = inject(BiometricsService);

  // If platform is not web, add clientid header
  if (bioS.bioInfo.Platform !== 'web') {
    const modifiedReq = req.clone({
      setHeaders: {
        ClientId: environment.MobileClientId,
        AuthToken: environment.AuthToken,
        Validate: req.url.includes(notificationsUrl) ? 'No' : environment.Validate,
        ...(req.url.includes(notificationsUrl) ? { ApiKey: environment.AuthToken } : {}),
      },
    });
    return next(modifiedReq);
  }

  return next(req);
};
